import { CECertificateBase } from './ce-certificate-base'


export class CECertificate extends CECertificateBase {

}